<span [innerHTML]="currentText">
</span>
    <span *ngIf='!hideToggle' class="cursorPointer readMoreStyle" [class.hidden]="hideToggle" (click)="toggleView()">read {{isCollapsed? 'more':'less'}}</span>
